import React, {  } from 'react';
import Markdown from 'react-markdown';
import PropTypes from 'prop-types';
import heroImg from '../images/provision.jpg';
import NavigationButtons from '../components/NavigationButtons';
import Helmet from 'react-helmet';

function Provisions({ data }) {
  const { provisionsMessage } = data;
  
  return (
    <div className="welcome-message">
      <Helmet>
        <title> | Provisions</title>
      </Helmet>
      <div className="hero-image">
        <img src={heroImg} alt="Provision" />
      </div>
      <h2>My Recommended Provisions</h2>
      <p><Markdown>{provisionsMessage}</Markdown></p>
      <NavigationButtons 
        propertyType={data.propertyType}
        showDetails={!!data.houseManualItems}
        showRestaurants={!!data.restaurantsMessage}
        showActivities={!!data.activitiesMessage}
        showProvisions={!!data.provisionsMessage}
      />
    </div>
  );
}

Provisions.propTypes = {
  data: PropTypes.object.isRequired
};
  
export default Provisions;